import { render, staticRenderFns } from "./CarouselMostPopular.vue?vue&type=template&id=7c46c9d6&"
import script from "./CarouselMostPopular.vue?vue&type=script&lang=js&"
export * from "./CarouselMostPopular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports